import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunkMiddleware from 'redux-thunk'
import { createReduxHistoryContext } from 'redux-first-history'
import { composeWithDevTools } from 'redux-devtools-extension'
import { getBankFromPath } from 'Utility/bankMethods'
import { createBrowserHistory } from 'history'
import { allSagas, injectSaga } from './sagas'
import loggerMiddleware from './middleware/logger'
import globals from './middleware/globals'
import monitorReducerEnhancer from './enhancers/monitorReducers'
import createReducer from './reducers'

const immutableStateInvariantMiddleware = require('redux-immutable-state-invariant').default()

export const { routerMiddleware, createReduxHistory, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
  savePreviousLocations: 1,
  basename: getBankFromPath() ? `/${getBankFromPath()}` : undefined
})

const composeEnhancers = composeWithDevTools({
  name: 'npg-fe-merchant-portal',
  trace: true,
  serialize: {
    options: {
      undefined: true,
      function(fn) {
        return fn.toString()
      }
    }
  }
})
const sagaMiddleware = createSagaMiddleware()

const rootStore = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middlewares = [sagaMiddleware, thunkMiddleware, routerMiddleware, globals]
  if (process.env.GTM_ID) {
    const { analytics } = require('Store/middleware/analytics')
    middlewares.push(analytics)
  }
  if (process.env.NODE_ENV !== 'production' && process.env.DEBUG_MODE === 'true') {
    middlewares.push(loggerMiddleware)
  }
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(immutableStateInvariantMiddleware)
  }

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [applyMiddleware(...middlewares)]
  if (process.env.DEBUG_MODE === 'true') {
    enhancers.push(monitorReducerEnhancer)
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    createReducer(),
    initialState,
    process.env.NODE_ENV === 'development' ? composeEnhancers(...enhancers) : compose(...enhancers)
  )

  store.asyncReducers = {}
  store.injectedSagas = {}
  store.runSaga = sagaMiddleware.run
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.asyncReducers))
    })
  }

  // setTimeout(
  //   () =>
  //     store.dispatch({
  //       type: 'REFRESH_PAGE',
  //       payload: {
  //         location: { pathname: window.location.pathname, pipo: true }
  //       }
  //     }),
  //   1500
  // )

  allSagas.forEach((sagas) => {
    injectSaga(store, { key: sagas.key, asyncSaga: sagas.value })
  })

  return store
}

export default rootStore()
